import { render, staticRenderFns } from "./HelpSection.vue?vue&type=template&id=2c4401c3&scoped=true"
import script from "./HelpSection.vue?vue&type=script&lang=js"
export * from "./HelpSection.vue?vue&type=script&lang=js"
import style0 from "./HelpSection.vue?vue&type=style&index=0&id=2c4401c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4401c3",
  null
  
)

export default component.exports